export default "__VITE_ASSET__ac964b58__"